import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <div className="hero">
      <div className="hero-image-container">
        <img src="/img/hero/heroimg2.webp" alt="Hospitality" className="hero-image" />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        <h1 className="hero-title">
          Creating commercial impact<br />
          through hospitality
        </h1>
        <button 
          className="hero-cta"
          onClick={() => {
            document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Connect with us
        </button>
      </div>
    </div>
  );
}

export default Hero;
